import { toast } from 'react-toastify';
import { apiFetch } from '../../actions/apiActions';
import { makeActionCreator } from '../../utils';

export const IMAGES_CHANGED = "IMAGES_CHANGED";
export const IMAGES_LOADING = "IMAGES_LOADING";
export const IMAGES_CLEAR_STATE = "IMAGES_CLEAR_STATE";
export const IMAGES_LAST_USED_ATTACHMENT = "IMAGES_LAST_USED_ATTACHMENT";
export const imagesDataChanged = makeActionCreator(IMAGES_CHANGED, "payload");
export const imagesIsLoading = makeActionCreator(IMAGES_LOADING, "payload");
export const imagesCreateState = makeActionCreator(IMAGES_CLEAR_STATE);
export const imagesLastUsedAttachment = makeActionCreator(IMAGES_LAST_USED_ATTACHMENT, "payload");

export function deleteFileInNextcloud(filePath) {
  return async (dispatch) => {
    try {
      let resp = await dispatch(
        apiFetch(`/api/data/delete`, {
          method: "DELETE",
          body: JSON.stringify({
            filePath: filePath
          })
        })
      );
      const jsonData = await resp.json();
      if (!resp.ok) {
        throw new Error(jsonData.message);
      }
    } catch (e) {
      toast(e.message, { type: "error" });
    }
  }
}

export function getFilesFromNextcloud() {
  return async (dispatch) => {
    try {
      let resp = await dispatch(
        apiFetch("/api/data/download/all", {
          method: "GET"
        })
      );
      const jsonData = await resp.json();
      if (!resp.ok) {
        throw new Error(jsonData.message);
      }
      dispatch(imagesDataChanged(jsonData.data))
      dispatch(imagesIsLoading(false));
    } catch (e) {
      toast(e.message, { type: "warning" });
    }
  }
}
